import { Language } from "@types";

export const HEADER_HEIGHT = 50;
export const APP_INSTALLER_HEIGHT = 40;
export const FONT_FAMILY_CLASSES: Record<Language, string> = {
  [Language.EN]: "font-en",
  [Language.TH]: "font-th",
};
export const BALANCE_BADGE_TOP_ID = "balance-badge-top";
